<template>
    <div class="reportDishKDStime defaultReport">
        <div class="filter-box">
            <div class="filter-bnts">
                <div class="bnt verticalCenter" :class="{selected:queryType==false}" @click="nowadays()" >
                    <div class="title">
                        <span>今天<br/>({{userInfo.Rpt_Date}})</span>
                    </div>
                </div>
                <div class="bnt verticalCenter" :class="{selected:queryType==true}"  @click="queryType=true"  v-if="ReportDataFromDays>=0">
                    <div class="title">
                        <span>按日期范围</span>
                    </div>
                </div>
                <div class="inline-block"  v-if="ReportDataFromDays>=0">
                    <el-date-picker class="from-date"
                        v-model="businessHours"
                        type="daterange"
                        start-placeholder="开始日期"
                        end-placeholder="结束日期"
                        :default-time="defaultTime"
                        @change="change"
                        :disabled='queryType==false'
                        :disabled-date="disabledDate"
                    > </el-date-picker>
                </div>
                <div class="inline-block" >
                    <div class="flex-box">
                        <div class="lable-txt">餐厅:</div>
                        <div class="from-input" style="width: 180px;">
                            <el-select v-model="roomids" multiple collapse-tags @removeTag="()=>roomids=[]">
                                <el-option :value="item.Room_AutoID" :label="item.Room_Code+'-'+ item.Room_Name" v-for="item in PosRooms" :key="item"></el-option>
                            </el-select>
                        </div>
                    </div>
                </div>
                <div class="inline-block">
                    <div class="flex-box eat">
                        <div class="lable-txt">时段:</div>
                        <div class="from-input">
                            <el-select v-model="salesValue" placeholder="全天" multiple collapse-tags @removeTag="()=>salesValue=[]">
                                <el-option
                                    v-for="item in eatPhases"
                                    :key="item.EAT_PHASEID"
                                    :label="item.EAT_PHASENAME"
                                    :value="item.EAT_PHASEID">
                                </el-option>
                            </el-select>
                        </div>
                    </div>
                </div>
                <div class="inline-block" >
                    <div class="flex-box">
                        <div class="lable-txt">销售渠道:</div>
                        <div class="from-input" style="width: 180px;">
                            <select-tree v-model="channelAutoIDs" placeholder="请选择" :data="treeOrderChannel" title="销售渠道选择">
                            </select-tree>
                        </div>
                    </div>
                </div>
                <div class="inline-block" >
                    <div class="flex-box">
                        <div class="lable-txt">菜品类别:</div>
                        <div class="from-input" style="width: 180px;">
                            <select-tree v-model="categoryIds" placeholder="请选择" :data="treeFoodMainCategory" title="菜品类别选择">
                            </select-tree>
                        </div>
                    </div>
                </div>
                <div class="inline-block">
                    <div class="flex-box">
                        <div class="lable-txt">菜品评分:</div>
                        <div class="from-input" style="width: 160px;">
                            <el-select v-model="score" placeholder="全部" multiple collapse-tags @removeTag="()=>score=[]">
                                <el-option :value="1" label="正常"></el-option>
                                <el-option :value="2" label="超时"></el-option>
                                <el-option :value="3" label="未完成"></el-option>
                                <el-option :value="4" label="不参与考核"></el-option>
                            </el-select>
                        </div>
                    </div>
                </div>
                <div class="inline-block" >
                    <div class="flex-box">
                        <el-select class="search-type" v-model="searchType" placeholder="按台号" >
                            <el-option :value="0" label="按台号"></el-option>
                            <el-option :value="1" label="按账单号"></el-option>
                            <el-option :value="2" label="按菜名"></el-option>
                            <el-option :value="3" label="按菜品超时>="></el-option>
                        </el-select>
                        <div class="from-input search-input">
                            <input-pattern type="text" pattern="number" v-if="searchType==3" v-model="searchText"  placeholder="模糊检索" />
                            <input type="text" v-else v-model="searchText"  placeholder="模糊检索" />
                        </div>
                        <div class="search-flex">
                            <div class="bnt-search" @click="loadData()" >查询</div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="right-bnts select">
                <div class="bnt" @click="exportExcel()"><i class="iconfont icon-daochu"></i>导出报表</div>
            </div>
            
        </div>
        <div class="content-box clearfix">
            <div class="nav-box-top">
                <div class="nav-box" v-mouse-scroll >
                    <div class="nav-li" :class="{selected:tagType==1}" @click="tagType=1">按桌台上齐标准时长维度</div>
                    <div class="nav-li" :class="{selected:tagType==2}" @click="tagType=2">按菜品制作标准时长维度</div>
                </div>
            </div>
            <div class="tab-pane" v-show="tagType==1">
                <div class="table-box grey-table isFooter headerCol2" ref="tableBox"   >
                    <el-table class="el-table--scrollable-y"  :data="tableListPage"  border ref="elTable" 
                        @sort-change="sortChange" 
                        show-summary
                        :summary-method="getSummaries"
                        :row-class-name="setClassName"
                        v-mouse-scroll="{scrollName:'.el-table__body-wrapper'}" :default-sort = "{prop: 'date', order: 'descending'}">
                        <el-table-column fixed prop="Rpt_Date" label="营业日期" min-width="90" :formatter="shortDateFormat"></el-table-column>
                        <el-table-column fixed prop="Eat_RoomName"  label="餐厅" min-width="110"></el-table-column>
                        <el-table-column fixed prop="Eat_PhaseName" label="时段" min-width="50"></el-table-column>
                        <el-table-column fixed prop="Eat_DeskName" align="left" label="桌号" min-width="90"></el-table-column>
                        <el-table-column label="桌台完成情况">
                            <template #header>
                                <template v-if="tableIsTransferTime">
                                    <el-tooltip  effect="dark" content="按传菜时间核算表示按传菜的时间来核算桌台是否完成" placement="top">
                                        <div class="tip">桌台完成情况-按传菜时间核算
                                            <svg class="icon-svg" aria-hidden="true">
                                                <use xlink:href="#icon-infoFilled"></use>
                                            </svg>
                                        </div>
                                    </el-tooltip>
                                </template>
                                <template v-else>
                                    <el-tooltip  effect="dark" content="按上齐时间核算表示按传菜的时间来核算桌台是否完成" placement="top">
                                        <div class="tip">桌台完成情况-按上齐时间核算
                                            <svg class="icon-svg" aria-hidden="true">
                                                <use xlink:href="#icon-infoFilled"></use>
                                            </svg>
                                        </div>
                                    </el-tooltip>
                                </template>
                            </template>
                            <el-table-column prop="StandardTime" label="标准时长" min-width="90"></el-table-column>
                            <el-table-column prop="BegCookTime" label="起菜时间" min-width="130" :formatter="dateFormat"></el-table-column>
                            <el-table-column prop="EndCookTime" label="上齐时间" min-width="130" :formatter="dateFormat"></el-table-column>
                            <el-table-column prop="AssessEndCookTime" label="理论完成时间" min-width="130" :formatter="dateFormat">
                                <template #header>
                                    <el-tooltip  effect="dark" content="理论完成时间=桌台起菜时间+标准时长" placement="top">
                                        <div class="tip">理论完成时间
                                            <svg class="icon-svg" aria-hidden="true">
                                                <use xlink:href="#icon-infoFilled"></use>
                                            </svg>
                                        </div>
                                    </el-tooltip>
                                </template>
                            </el-table-column>
                            <el-table-column prop="DeskStatus" class-name="DeskStatus" label="桌号评分" min-width="90">
                                <template #default="scope">{{({1:"正常",2:"超时",3:"未完成"})[scope.row.DeskStatus]}}</template>
                            </el-table-column>
                        </el-table-column>
                        <el-table-column sortable prop="Eat_KindName" label="菜品小类" min-width="100" align="left"></el-table-column>
                        <el-table-column sortable prop="Eat_XfbmCode" label="菜品编码" min-width="100" align="left"></el-table-column>
                        <el-table-column sortable prop="Eat_XfbmName" label="菜品名称" min-width="100" align="left"></el-table-column>
                        <el-table-column sortable prop="Eat_XFSize" label="单位" min-width="80" align="left"></el-table-column>
                        <el-table-column sortable prop="IsKDSNoShow" label="是否考核" min-width="100">
                            <template #header>
                                <el-tooltip  effect="dark" content="来源菜品设置项【KDS不显示】作为不考菜品" placement="top">
                                    <div class="tip">是否考核
                                        <svg class="icon-svg" aria-hidden="true">
                                            <use xlink:href="#icon-infoFilled"></use>
                                        </svg>
                                    </div>
                                </el-tooltip>
                            </template>
                            <template #default="scope">
                                <template v-if="scope.isExcel">
                                    {{scope.row.IsKDSNoShow?"否":"是"}}
                                </template>
                                <span class="kdsNoShow" v-else>
                                    <i class="iconfont icon-cha" v-if="scope.row.IsKDSNoShow"></i>
                                    <i class="iconfont icon-gou" v-else></i>
                                </span>
                            </template>
                        </el-table-column>
                        <el-table-column sortable prop="Eat_Number" label="点单数量" min-width="80" align="right" :formatter="priceFormat" data-format="number"></el-table-column>
                        <el-table-column sortable prop="Refund_Number" label="退单数量" min-width="80" align="right" :formatter="priceFormat" data-format="number"></el-table-column>
                        <el-table-column sortable prop="Eat_Czy" label="点单员" min-width="80" align="left"></el-table-column>
                        <el-table-column sortable prop="Eat_Time" label="下单时间" min-width="130" :formatter="dateFormat"></el-table-column>
                        <el-table-column sortable prop="FoodBegCookTime" label="起菜时间" min-width="130" :formatter="dateFormat"></el-table-column>
                        <el-table-column label="切配">
                            <template #header>
                                <el-tooltip  effect="dark" content="配菜时长=完成时间-起菜时间" placement="top">
                                    <div class="tip">切配
                                        <svg class="icon-svg" aria-hidden="true">
                                            <use xlink:href="#icon-infoFilled"></use>
                                        </svg>
                                    </div>
                                </el-tooltip>
                            </template>
                            <el-table-column sortable prop="Cut_Czy" label="切配人" min-width="80" align="left"></el-table-column>
                            <el-table-column sortable prop="Cut_EndTime" label="完成时间" min-width="80"></el-table-column>
                            <el-table-column sortable prop="CutTime" label="配菜时长" min-width="80" data-format="number"></el-table-column>
                        </el-table-column>
                        <el-table-column label="制作">
                            <template #header>
                                <el-tooltip  effect="dark" content="制作时长=完成时间-起菜时间" placement="top">
                                    <div class="tip">制作
                                        <svg class="icon-svg" aria-hidden="true">
                                            <use xlink:href="#icon-infoFilled"></use>
                                        </svg>
                                    </div>
                                </el-tooltip>
                            </template>
                            <el-table-column sortable prop="Do_Czy" label="制作人" min-width="80" align="left"></el-table-column>
                            <el-table-column sortable prop="Do_EndTime" label="完成时间" min-width="80"></el-table-column>
                            <el-table-column sortable prop="DoTime" label="制作时长" min-width="80" data-format="number"></el-table-column>
                        </el-table-column>
                        <el-table-column label="传菜">
                            <template #header>
                                <el-tooltip  effect="dark" content="传菜时长=完成时间-起菜时间" placement="top">
                                    <div class="tip">传菜
                                        <svg class="icon-svg" aria-hidden="true">
                                            <use xlink:href="#icon-infoFilled"></use>
                                        </svg>
                                    </div>
                                </el-tooltip>
                            </template>
                            <el-table-column sortable prop="Transfer_Czy" label="传菜人" min-width="80" align="left"></el-table-column>
                            <el-table-column sortable prop="Transfer_EndTime" label="完成时间" min-width="80"></el-table-column>
                            <el-table-column sortable prop="TransferTime" label="传菜时长" min-width="80" data-format="number"></el-table-column>
                        </el-table-column>
                        <el-table-column label="上桌">
                            <template #header>
                                <el-tooltip  effect="dark" content="上桌时长=完成时间-起菜时间" placement="top">
                                    <div class="tip">上桌
                                        <svg class="icon-svg" aria-hidden="true">
                                            <use xlink:href="#icon-infoFilled"></use>
                                        </svg>
                                    </div>
                                </el-tooltip>
                            </template>
                            <el-table-column sortable prop="OnDesk_Czy" label="上桌人" min-width="80" align="left"></el-table-column>
                            <el-table-column sortable prop="OnDesk_EndTime" label="完成时间" min-width="80" ></el-table-column>
                            <el-table-column sortable prop="OnDeskTime" label="上桌时长" min-width="80" data-format="number"></el-table-column>
                        </el-table-column>
                        <el-table-column label="超时参考【按传菜时间】">
                            <el-table-column sortable prop="FoodStatus" label="菜品评分" min-width="80">
                                <template #default="scope">{{({1:"正常",2:"超时",3:"未完成",4:"不参与考核"})[scope.row.FoodStatus]}}</template>
                            </el-table-column>
                            <el-table-column sortable prop="OverTime" label="超时时长" min-width="100" data-format="number">
                                <template #header>
                                    <template v-if="tableIsTransferTime">
                                        <el-tooltip effect="dark" content="超时时长=传菜完成时间-理论完成时间" placement="top">
                                            <div class="tip">超时时长
                                                <svg class="icon-svg" aria-hidden="true">
                                                    <use xlink:href="#icon-infoFilled"></use>
                                                </svg>
                                            </div>
                                        </el-tooltip>
                                    </template>
                                    <template v-else>
                                        <el-tooltip effect="dark" content="超时时长=上桌完成时间-理论完成时间" placement="top">
                                            <div class="tip">超时时长
                                                <svg class="icon-svg" aria-hidden="true">
                                                    <use xlink:href="#icon-infoFilled"></use>
                                                </svg>
                                            </div>
                                        </el-tooltip>
                                    </template>
                                </template>
                            </el-table-column>
                        </el-table-column>
                        <el-table-column sortable prop="Eat_CheckNo" label="结账单号" min-width="120"></el-table-column>
                        <el-table-column sortable prop="Eat_BTime" label="开台时间" min-width="130" :formatter="dateFormat"></el-table-column>
                        <el-table-column sortable prop="Eat_ETime" label="结账时间" min-width="130" :formatter="dateFormat"></el-table-column>
                        <el-table-column sortable prop="Channel_Name" label="销售渠道" min-width="100"></el-table-column>
                        <el-table-column sortable prop="Consume_TypeName" label="消费类型" min-width="100"></el-table-column>
                    </el-table>
                </div>
                <table-page-btn class="fy" :data="tableFilter" 
                    :default-index="currentPage" 
                    @current-change="(index)=>currentPage=index"
                    @page-change="(list)=>tableListPage=list" 
                    :page-size="pagesize"></table-page-btn>
            </div>
            <div class="tab-pane" v-show="tagType==2">
                <div class="table-box grey-table isFooter headerCol2" ref="tableBox2"   >
                    <el-table class="el-table--scrollable-y"  :data="tableListPage2"  border ref="elTable2" 
                        @sort-change="sortChange2" 
                        show-summary
                        :summary-method="getSummaries2"
                        :row-class-name="setClassName"
                        v-mouse-scroll="{scrollName:'.el-table__body-wrapper'}" :default-sort = "{prop: 'date', order: 'descending'}">
                        <el-table-column fixed prop="Rpt_Date" label="营业日期" min-width="90" :formatter="shortDateFormat"></el-table-column>
                        <el-table-column fixed prop="Eat_RoomName"  label="餐厅" min-width="110"></el-table-column>
                        <el-table-column fixed prop="Eat_PhaseName" label="时段" min-width="50"></el-table-column>
                        <el-table-column fixed prop="Eat_DeskName" align="left" label="桌号" min-width="90"></el-table-column>
                        <el-table-column sortable prop="Eat_KindName" label="菜品小类" min-width="100" align="left"></el-table-column>
                        <el-table-column sortable prop="Eat_XfbmCode" label="菜品编码" min-width="100" align="left"></el-table-column>
                        <el-table-column sortable prop="Eat_XfbmName" label="菜品名称" min-width="100" align="left"></el-table-column>
                        <el-table-column sortable prop="Eat_XFSize" label="单位" min-width="80" align="left"></el-table-column>
                        <el-table-column sortable prop="IsKDSNoShow" label="是否考核" min-width="100">
                            <template #header>
                                <el-tooltip  effect="dark" content="来源菜品设置项【KDS不显示】作为不考菜品" placement="top">
                                    <div class="tip">是否考核
                                        <svg class="icon-svg" aria-hidden="true">
                                            <use xlink:href="#icon-infoFilled"></use>
                                        </svg>
                                    </div>
                                </el-tooltip>
                            </template>
                            <template #default="scope">
                                <template v-if="scope.isExcel">
                                    {{scope.row.IsKDSNoShow?"否":"是"}}
                                </template>
                                <span class="kdsNoShow" v-else>
                                    <i class="iconfont icon-cha" v-if="scope.row.IsKDSNoShow"></i>
                                    <i class="iconfont icon-gou" v-else></i>
                                </span>
                            </template>
                        </el-table-column>
                        <el-table-column sortable prop="Eat_Number" label="点单数量" min-width="80" align="right" :formatter="priceFormat" data-format="number"></el-table-column>
                        <el-table-column sortable prop="Refund_Number" label="退单数量" min-width="80" align="right" :formatter="priceFormat" data-format="number"></el-table-column>
                        <el-table-column sortable prop="Eat_Czy" label="点单员" min-width="80" align="left"></el-table-column>
                        <el-table-column sortable prop="Eat_Time" label="下单时间" min-width="130" :formatter="dateFormat"></el-table-column>
                        <el-table-column sortable prop="FoodBegCookTime" label="起菜时间" min-width="130" :formatter="dateFormat"></el-table-column>
                        <el-table-column label="切配">
                            <template #header>
                                <el-tooltip  effect="dark" content="配菜时长=完成时间-起菜时间" placement="top">
                                    <div class="tip">切配
                                        <svg class="icon-svg" aria-hidden="true">
                                            <use xlink:href="#icon-infoFilled"></use>
                                        </svg>
                                    </div>
                                </el-tooltip>
                            </template>
                            <el-table-column sortable prop="Cut_Czy" label="切配人" min-width="80" align="left"></el-table-column>
                            <el-table-column sortable prop="Cut_EndTime" label="完成时间" min-width="80"></el-table-column>
                            <el-table-column sortable prop="CutTime" label="配菜时长" min-width="80" data-format="number"></el-table-column>
                        </el-table-column>
                        <el-table-column label="制作">
                            <template #header>
                                <el-tooltip  effect="dark" content="制作时长=完成时间-起菜时间" placement="top">
                                    <div class="tip">制作
                                        <svg class="icon-svg" aria-hidden="true">
                                            <use xlink:href="#icon-infoFilled"></use>
                                        </svg>
                                    </div>
                                </el-tooltip>
                            </template>
                            <el-table-column sortable prop="Do_Czy" label="制作人" min-width="80" align="left"></el-table-column>
                            <el-table-column sortable prop="Do_EndTime" label="完成时间" min-width="80"></el-table-column>
                            <el-table-column sortable prop="DoTime" label="制作时长" min-width="80" data-format="number"></el-table-column>
                        </el-table-column>
                        <el-table-column label="传菜">
                            <template #header>
                                <el-tooltip  effect="dark" content="传菜时长=完成时间-起菜时间" placement="top">
                                    <div class="tip">传菜
                                        <svg class="icon-svg" aria-hidden="true">
                                            <use xlink:href="#icon-infoFilled"></use>
                                        </svg>
                                    </div>
                                </el-tooltip>
                            </template>
                            <el-table-column sortable prop="Transfer_Czy" label="传菜人" min-width="80" align="left"></el-table-column>
                            <el-table-column sortable prop="Transfer_EndTime" label="完成时间" min-width="80"></el-table-column>
                            <el-table-column sortable prop="TransferTime" label="传菜时长" min-width="80" data-format="number"></el-table-column>
                        </el-table-column>
                        <el-table-column label="上桌">
                            <template #header>
                                <el-tooltip  effect="dark" content="上桌时长=完成时间-起菜时间" placement="top">
                                    <div class="tip">上桌
                                        <svg class="icon-svg" aria-hidden="true">
                                            <use xlink:href="#icon-infoFilled"></use>
                                        </svg>
                                    </div>
                                </el-tooltip>
                            </template>
                            <el-table-column sortable prop="OnDesk_Czy" label="上桌人" min-width="80" align="left"></el-table-column>
                            <el-table-column sortable prop="OnDesk_EndTime" label="完成时间" min-width="80" ></el-table-column>
                            <el-table-column sortable prop="OnDeskTime" label="上桌时长" min-width="80" data-format="number"></el-table-column>
                        </el-table-column>
                        <el-table-column label="系统标准值">
                            <el-table-column sortable prop="StandardTime" label="标准时长" min-width="100" data-format="number"></el-table-column>
                            <el-table-column sortable prop="AssessEndCookTime" label="理论完成时间" min-width="120">
                                <template #header>
                                    <el-tooltip  effect="dark" content="理论完成时间=桌台起菜时间+标准时长" placement="top">
                                        <div class="tip">理论完成时间
                                            <svg class="icon-svg" aria-hidden="true">
                                                <use xlink:href="#icon-infoFilled"></use>
                                            </svg>
                                        </div>
                                    </el-tooltip>
                                </template>
                            </el-table-column>
                        </el-table-column>
                        <el-table-column label="超时参考【按传菜时间】">
                            <el-table-column sortable prop="FoodStatus" label="菜品评分" min-width="80">
                                <template #default="scope">{{({1:"正常",2:"超时",3:"未完成",4:"不参与考核"})[scope.row.FoodStatus]}}</template>
                            </el-table-column>
                            <el-table-column sortable prop="OverTime" label="超时时长" min-width="100" data-format="number">
                                <template #header>
                                    <template v-if="table2IsTransferTime">
                                        <el-tooltip effect="dark" content="超时时长=传菜完成时间-理论完成时间" placement="top">
                                            <div class="tip">超时时长
                                                <svg class="icon-svg" aria-hidden="true">
                                                    <use xlink:href="#icon-infoFilled"></use>
                                                </svg>
                                            </div>
                                        </el-tooltip>
                                    </template>
                                    <template v-else>
                                        <el-tooltip effect="dark" content="超时时长=上桌完成时间-理论完成时间" placement="top">
                                            <div class="tip">超时时长
                                                <svg class="icon-svg" aria-hidden="true">
                                                    <use xlink:href="#icon-infoFilled"></use>
                                                </svg>
                                            </div>
                                        </el-tooltip>
                                    </template>
                                </template>
                            </el-table-column>
                        </el-table-column>
                        <el-table-column sortable prop="Eat_CheckNo" label="结账单号" min-width="120"></el-table-column>
                        <el-table-column sortable prop="Eat_BTime" label="开台时间" min-width="130" :formatter="dateFormat"></el-table-column>
                        <el-table-column sortable prop="Eat_ETime" label="结账时间" min-width="130" :formatter="dateFormat"></el-table-column>
                        <el-table-column sortable prop="Channel_Name" label="销售渠道" min-width="100"></el-table-column>
                        <el-table-column sortable prop="Consume_TypeName" label="消费类型" min-width="100"></el-table-column>
                    </el-table>
                </div>
                <table-page-btn class="fy" :data="table2Filter" 
                    :default-index="currentPage2" 
                    @current-change="(index)=>currentPage2=index"
                    @page-change="(list)=>tableListPage2=list" 
                    :page-size="pagesize2"></table-page-btn>
            </div>
        </div>
     </div>
</template>
<script>


/**出菜时长分析表 */
export default {
    name:'reportDishKDStime',
    data(){
        return {
            //页签
            tagType:1,
            userInfo:{},
            /**表格数据 */ 
            currentPage:1,
            tableList:[],
            tableListPage:[],
            pagesize:9,//每页的数据条数
            //排序用
            sortable:null,
            /**表格数据 明细数据 */ 
            currentPage2:1,
            tableList2:[],
            tableListPage2:[],
            pagesize2:9,//每页的数据条数
            //排序用
            sortable2:null,
            //是否按传菜时间  0:按上桌时间  1:按转菜时间
            tableIsTransferTime:false,
            //是否按传菜时间  0:按上桌时间  1:按转菜时间
            table2IsTransferTime:false,
            /**默认日期范围 */
            defaultTime:[new Date(),new Date()],
            /**选中日期范围 */
            businessHours:[new Date(),new Date()],
            /**true: 日期范围    false：当前营业数据*/
            queryType:false,
            //桌台数据
            PosRooms:[],
            //餐厅id
            roomids:[],
            //时段数据
            eatPhases:null,
            //时段
            salesValue:[],
            //渠道数据
            orderChannel:null,
            //渠道id
            channelAutoIDs:[],
            /**菜品数据 */
            posFoodData:[],
            /**菜品分类id */
            categoryIds:[],
            /**菜品评分 1-正常 2-超时 3-未完成*/
            score:[],
           
            tempParam:null,
            /**检索类型 0按台号 1按账单号 2按菜名 3按菜品超时>=*/
            searchType:0,
            //模糊检索
            searchText:'',
            
        }
    },
    mounted(){
        this.userInfo = this.$auth.getUserInfo();
        this.nowadays();
        //时段数据
        this.$cacheData.EatPhase().then((d)=>{
            if(d){
                this.eatPhases=d;
            }
        }).catch((e)=>{
            this.$message.error('加载时段数据失败：'+e.message);
            console.log('加载时段数据失败：'+e);
        })
        //渠道数据
        this.$cacheData.OrderChannel().then((d)=>{
            if(d){
                this.orderChannel=d;
            }
        }).catch((e)=>{
            this.$message.error('加载渠道数据失败：'+e.message);
            console.log('加载渠道数据失败：'+e);
        })
        this.$cacheData.EatRooms().then((d)=>{
            this.PosRooms=d;
        }).catch((e)=>{
            this.$alert("桌台数据加载失败"+e.message, "提示", {confirmButtonText: "确定"});
        });
        //菜品数据结构
        this.$cacheData.AllPosFoods().then((d)=>{
            this.posFoodData=d;
        }).catch(e=>{
            console.log('e:'+e)
            this.$alert('未找到菜品数据', "提示", {confirmButtonText: "确定"});
        })
        this.$nextTick(()=>{
            this.loadData();
        });
    },
    watch:{
        searchType(newVal,oldVal){
            if(this.searchType==3){
                this.searchText="";
            }else if(oldVal==3){
                this.searchText="";
            }
        }
    },
    computed:{
         //限制门店用户查看几天以内的报表, -1:不能查看历史数据，0:不限制，大于0：限制查看几天内的报表
        ReportDataFromDays(){
            return this.$cacheData?.globalVariable?.GlobalSysSetting.AllowUserViewReportDataFromDays||0
        },
        //渠道数据
        treeOrderChannel(){
            let treeData=[];
            this.orderChannel?.map((group)=>{
                let json={
                    id:group.OrderChannelKind_AutoID,
                    name:group.OrderChannelKind_Code+group.OrderChannelKind_Name,
                    children:[],
                    Hierarchy:1
                }
                if(group.OrderChannelList){
                    group.OrderChannelList.map(item=>{
                        let children= Object.assign({
                            id:item.OrderChannel_AutoID,
                            name:item.OrderChannel_Code+'-'+item.OrderChannel_Name,
                            Hierarchy:2
                        },item)
                        json.children.push(children)
                    })
                }
                treeData.push(json)
            })
            return treeData;
        },
        //分类数据
        treeFoodMainCategory(){
            let foodMainCategory=[];
            this.posFoodData?.forEach(item=>{
                let depart={
                    id:item.MainCategory_ID,
                    name:item.MainCategory_Name,
                    children:[],
                    Hierarchy:1
                }
                if(item.FoodSubCategorys){
                    item.FoodSubCategorys.forEach(eat=>{
                        let chieat={
                            id:eat.SubCategory_ID,
                            name:eat.SubCategory_Name,
                            Hierarchy:2
                        }
                        depart.children.push(chieat)
                    })
                }
                foodMainCategory.push(depart)
            })
            return [{
                id:1,
                name:"全选",
                children:foodMainCategory
            }];
        },
        //合计
        total(){
            let total={
                Eat_Number:0,
                Refund_Number:0,
            };
            (this.tableList||[]).forEach(it=>{
                total.Eat_Number+=it.Eat_Number;
                total.Refund_Number+=it.Refund_Number;
            })
            return total;
        },
        //合计
        total2(){
            let total={
                Eat_Number:0,
                Refund_Number:0,
            };
            (this.tableList2||[]).forEach(it=>{
                total.Eat_Number+=it.Eat_Number;
                total.Refund_Number+=it.Refund_Number;
            })
            return total;
        },
        /**过滤数据 */
        tableFilter(){
            let list=this.tableList||[];
            if(this.roomids?.length>0){//餐厅
                list=list.filter(it=>this.roomids.indexOf(it.Eat_RoomID)>=0);
            }

            if(this.salesValue?.length>0){//时段
                list=list.filter(it=>this.salesValue.indexOf(it.Eat_PhaseID)>=0);
            }

            if(this.channelAutoIDs?.length>0){//渠道
                list=list.filter(it=>this.channelAutoIDs.indexOf(it.Channel_ID)>=0);
            }

            if(this.categoryIds?.length>0){//菜品类别
                list=list.filter(it=>this.categoryIds.indexOf(it.Eat_KindID)>=0);
            }

            if(this.score?.length>0){//菜品评分
                list=list.filter(it=>this.score.indexOf(it.FoodStatus)>=0);
            }

            if((this.searchText||"").trim()){
                let text=(this.searchText||"").trim().toUpperCase();
                if(this.searchType==0){//按台号
                    list=list.filter(it=>(it.Eat_DeskName||"").toUpperCase().indexOf(text)>=0);
                }else if(this.searchType==1){//按账单号
                    list=list.filter(it=>(it.Eat_CheckNo||"").toUpperCase().indexOf(text)>=0);
                }else if(this.searchType==2){//按菜名
                    list=list.filter(it=>(it.Eat_XfbmName||"").toUpperCase().indexOf(text)>=0);
                }else if(this.searchType==3){//按菜品超时>=
                    list=list.filter(it=>Number(it.OverTime||0)>=(Number(text)||0));
                }
            }

            //排序
            if(this.sortable){
                let sorttype=this.sortable.order=='ascending'?'asc':'desc';
                list=Object.assign([],list).order(this.sortable.prop,sorttype);
            }
            return list;
        },
        /**明细数据 条件筛选 */
        table2Filter(){
            let list=Object.assign([],this.tableList2);
            if(this.roomids?.length>0){//餐厅
                list=list.filter(it=>this.roomids.indexOf(it.Eat_RoomID)>=0);
            }

            if(this.salesValue?.length>0){//时段
                list=list.filter(it=>this.salesValue.indexOf(it.Eat_PhaseID)>=0);
            }

            if(this.channelAutoIDs?.length>0){//渠道
                list=list.filter(it=>this.channelAutoIDs.indexOf(it.Channel_ID)>=0);
            }

            if(this.categoryIds?.length>0){//菜品类别
                list=list.filter(it=>this.categoryIds.indexOf(it.Eat_KindID)>=0);
            }

            if(this.score?.length>0){//菜品评分
                list=list.filter(it=>this.score.indexOf(it.FoodStatus)>=0);
            }

            if((this.searchText||"").trim()){
                let text=(this.searchText||"").trim().toUpperCase();
                if(this.searchType==0){//按台号
                    list=list.filter(it=>(it.Eat_DeskName||"").toUpperCase().indexOf(text)>=0);
                }else if(this.searchType==1){//按账单号
                    list=list.filter(it=>(it.Eat_CheckNo||"").toUpperCase().indexOf(text)>=0);
                }else if(this.searchType==2){//按菜名
                    list=list.filter(it=>(it.Eat_XfbmName||"").toUpperCase().indexOf(text)>=0);
                }else if(this.searchType==3){//按菜品超时>=
                    list=list.filter(it=>Number(it.OverTime||0)>=(Number(text)||0));
                }
            }
            //排序
            if(this.sortable2){
                let sorttype=this.sortable2.order=='ascending'?'asc':'desc';
                list=Object.assign([],list).order(this.sortable2.prop,sorttype);
            }
            return list;
        }
    },
    methods:{
        disabledDate(d){
            if(this.ReportDataFromDays>0 && this.userInfo.Rpt_Date){
                const oneDay =  24 * 3600 * 1000;
                const day = this.ReportDataFromDays * oneDay;
                let maxDate=new Date(this.userInfo.Rpt_Date).getTime()-oneDay;
                let minDate=maxDate-day;
                if(minDate>=d.getTime() || maxDate<d.getTime()){
                    return true;
                }
            }
            return false;
        },
        /**数据排序 */
        sortChange(column){
            this.sortable=column;
            this.currentPage=1;
        },
        /**数据排序 */
        sortChange2(column){
            this.sortable2=column;
            this.currentPage2=1;
        },
        /**计算 一页显示多少条数据 */
        setTablePageSize(){
            if(this.$refs.tableBox){
                this.$nextTick(()=>{
                    let height=this.$refs.tableBox.clientHeight - 120;
                    this.pagesize=parseInt(height/50);
                })
            }
        },
        /**计算 一页显示多少条数据 */
        setTablePageSize2(){
            if(this.$refs.tableBox2){
                this.$nextTick(()=>{
                    let height=this.$refs.tableBox2.clientHeight - 120;
                    this.pagesize2=parseInt(height/50);
                })
            }
        },
        /**Excel导出 */
        exportExcel(){
            if(!this.$cacheData?.globalVariable?.GlobalSysSetting.AllowUserPrintReports){
                this.$message.warning('您没有导出报表权限，请先分配权限！');
                return;
            }
            if(this.tagType==1){
                this.$excelCommon.elTableToExcel({
                    elTable:this.$refs.elTable,
                    titleName:"出菜时长分析表-按桌台上齐标准时长维度",
                    list:this.tableFilter,
                })
            }else{
                this.$excelCommon.elTableToExcel({
                    elTable:this.$refs.elTable2,
                    titleName:"出菜时长分析表-按菜品制作标准时长维度",
                    list:this.table2Filter,
                })
            }
        },
        //设置列类名
        setClassName({ row }){
            if(row.DeskStatus==1){//1 正常
                return "normal";
            }else if(row.DeskStatus==2 || row.DeskStatus==3){//2超时  3未完成
                return "timeout";
            }
            return '';
        },
        /**今日 */
        nowadays(){
            this.queryType=false
            let Rpt_Date=new Date(this.userInfo.Rpt_Date);
            Rpt_Date.setDate(Rpt_Date.getDate()-1);
            this.businessHours=[Rpt_Date.Format("yyyy-MM-dd"),Rpt_Date.Format("yyyy-MM-dd")];
        },
        change(){
            if(this.queryType==false){
                this.queryType=true
            }
        },
        /*时间格式 */
        dateFormat(row, column, cellValue) {
            if(!cellValue || cellValue=='0001-01-01T00:00:00'){
                return '';
            }
            return (new Date(cellValue)).Format('yyyy-MM-dd hh:mm:ss');
        },
        /*时间格式 */
        shortDateFormat(row, column, cellValue){
            if(!cellValue || cellValue=='0001-01-01T00:00:00'){
                return '';
            }
            return (new Date(cellValue)).Format('yyyy-MM-dd');
        },
        /*单价格式 截取两位小数 */
        priceFormat(row, column, cellValue){
            if(isNaN(cellValue)){
                return ""
            }else{
                return parseFloat(parseFloat(cellValue).toFixed(2));
            }
        },
        getSummaries({ columns, data }){
            const sums= [];
            columns.forEach((column, index) => {
                if(this.total[column.property]!=undefined){
                    sums[index]=this.priceFormat(null,null,this.total[column.property]);
                }else{
                    sums[index]="";
                }
            })
            sums[0]="合计";
            return sums;
        },
        getSummaries2({ columns, data }){
            const sums= [];
            columns.forEach((column, index) => {
                if(this.total2[column.property]!=undefined){
                    sums[index]=this.priceFormat(null,null,this.total2[column.property]);
                }else{
                    sums[index]="";
                }
            })
            sums[0]="合计";
            return sums;
        },
        //查询数据
        loadData(){
            if(this.tagType==1){
                this.getDeskReport();
            }else{
                this.getFoodReport();
            }
        },
        /**查询  桌台维度*/
        getDeskReport(){
            let time = JSON.parse(JSON.stringify(this.businessHours));
            let param={
                User_ID:this.userInfo?.User_ID,
                Operator_Name:this.userInfo?.Login_Name,
                DateRange_YN:this.queryType,//是否日期范围查询  true: 日期范围    false：当前营业数据
                Begin_Date:new Date(time[0]).Format("yyyy-MM-dd"),//开始日期
                End_Date:new Date(time[1]).Format("yyyy-MM-dd"), //结束日期
            }
            const loading = this.$loading({
                text: "查询中...",
                spinner: "el-icon-loading",
                background: "rgba(0, 0, 0, 0.7)",
            });
            this.$httpAES.post("Bestech.CloudPos.FoodTimeAnalysisByDeskReport",param).then((d)=>{
                loading.close();
                if(d.ResponseHeader.ResultCode==0){
                    console.log(d)
                    this.tableList=d.ResponseBody;
                    this.setTablePageSize();
                    this.currentPage=1;
                    if(this.tableList?.length>0){
                        this.tableIsTransferTime=this.tableList[0].IsTransferTime;
                    }
                }else{
                    this.tableList=[];
                    this.currentPage=1;
                    this.$message.error(d.ResponseHeader.ResultDesc);
                }
            }).catch((e)=>{
                this.tableList=[];
                loading.close();
                this.$message.error(e.message);
                console.log(e);
            })
        },
        /**查询 菜品维度*/
        getFoodReport(){
            let time = JSON.parse(JSON.stringify(this.businessHours));
            let param={
                User_ID:this.userInfo?.User_ID,
                Operator_Name:this.userInfo?.Login_Name,
                DateRange_YN:this.queryType,//是否日期范围查询  true: 日期范围    false：当前营业数据
                Begin_Date:new Date(time[0]).Format("yyyy-MM-dd"),//开始日期
                End_Date:new Date(time[1]).Format("yyyy-MM-dd"), //结束日期
            }
            const loading = this.$loading({
                text: "查询中...", 
                spinner: "el-icon-loading",
                background: "rgba(0, 0, 0, 0.7)",
            });
            this.$httpAES.post("Bestech.CloudPos.FoodTimeAnalysisByFoodReport",param).then((d)=>{
                loading.close();
                if(d.ResponseHeader.ResultCode==0){
                    this.tableList2=d.ResponseBody;
                    console.log(d)
                    this.setTablePageSize2();
                    this.currentPage2=1;
                    if(this.tableList2?.length>0){
                        this.table2IsTransferTime=this.tableList2[0].IsTransferTime;
                    }
                }else{
                    this.tableList=[];
                    this.currentPage2=1;
                    this.$message.error(d.ResponseHeader.ResultDesc);
                }
            }).catch((e)=>{
                this.tableList2=[];
                loading.close();
                this.$message.error(e.message);
                console.log(e);
            })
        }
    }
}
</script>

<style lang="scss" >
@import './reportDishKDStime.scss'
</style>